import React from "react";
import TextInputField from "../../../pages/shared/components/formik/text-input";
import { TextInputProps } from "../text-input/types";
import { MaskedInput } from "../masked-input";
import { InputBaseComponentProps } from "@mui/material";

const CustomMaskedInputAmount = React.forwardRef<
  HTMLInputElement,
  InputBaseComponentProps
>((props, ref): React.JSX.Element => {
  return (
    <MaskedInput
      {...props}
      ref={ref}
      mask={Number}
      scale={0}
      min={0}
      max={999999}
      thousandsSeparator=" "
    />
  );
});
CustomMaskedInputAmount.displayName = "CustomMaskedInputAmount";

export default function AmountField({
  value,
  name,
  label,
  helperUnderInput,
  onBlur,
}: TextInputProps): React.ReactElement {
  return (
    <TextInputField
      CustomInputComponent={CustomMaskedInputAmount}
      name={name}
      label={label}
      value={value}
      type="tel"
      helperUnderInput={helperUnderInput}
      onBlur={onBlur}
    />
  );
}
